import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { ProjectActivity } from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity';
import { ProjectHolder } from 'projects/app-misc/src/app/modules/project-misc/interfaces/project-holder';
import { ProjectActivityService } from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import { ProjectInfoComponent } from '../../project-info/project-info.component';
import { MatDialog } from '@angular/material/dialog';
import { trackEntityById } from 'projects/core/src/public-api';
import { WsUpdateResponce } from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import { WsService } from 'projects/app-misc/src/app/modules/data/ws.service';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { Subject, Subscription } from 'rxjs';

@Component({
	selector: 'app-mobile-activities',
	templateUrl: './mobile-activities.component.html',
	styleUrls: ['./mobile-activities.component.scss']
})
@RxJSUnsubscribe
export class MobileActivitiesComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

	project: Project;

	@Input()
	title: string;

	@Input()
	projectActivities: ProjectActivity[];

	@Input()
	projectId: number;

	hours: string;

	trackEntityById = trackEntityById;
  wsSub: Subscription;

	constructor(
		protected wsService: WsService,
		protected projectHolder: ProjectHolder,
		private dialog: MatDialog,
		private projectActivityService: ProjectActivityService,
		protected projectInfoComponent: ProjectInfoComponent
	) {
		this.project = this.projectHolder.project
	}

	ngOnInit() {
    this.wsSub = this.wsService
			.listenUntilDestroyed<WsUpdateResponce<ProjectActivity>>('/topic/update/model.activity.Activity', this)
			.pipe(
				filter(updateInfo => {
					if (updateInfo.entity.project && updateInfo.entity.project.id === this.projectId) {
						return true;
					}
					else if (!updateInfo.entity.project && !!this.projectActivities.find(activity => activity.id === updateInfo.entity.id)) {
						return true;
					}
					return false
				}),
				debounceTime(2000)

			)
			.subscribe(updateInfo => {
				this.getProjectActivities();
			})
	}

	getProjectActivities() {
		this.projectActivityService.getProjectActivities(this.projectId).subscribe(projectActivities => {
			this.projectActivities = projectActivities
		})
	}

	ngOnDestroy() {
    if(this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
	}

	getUnsubFromAllSubs(): Subject<boolean> {
		return null
	}

}
